import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword, controllaInsulti } from "../../api";
import { Button } from "../../components/common/Button";

export const ResetPasswordPage:React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const uid = searchParams.get("uid") ?? "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Funzione di valutazione della forza della password
  const getPasswordStrength = (pwd: string) => {
    if (pwd.length < 8) return "Debole";
    const hasNumber = /\d/.test(pwd);
    const hasUpper = /[A-Z]/.test(pwd);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(pwd);
    if (hasNumber && hasUpper && hasSpecial) return "Forte";
    return "Media";
  };

  const strength = getPasswordStrength(password);

  const handleSetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("La password deve essere lunga almeno 8 caratteri");
      return;
    }
    if (password !== confirm) {
      setError("Le password non coincidono");
      return;
    }
    if (controllaInsulti(password)) {
      setError("La password non può contenere insultiall'FSM PORCA!!!");
      return;
    }

    setLoading(true);
    try {
      await resetPassword({ uid: uid, token: token, new_password: password });
      navigate("/login", { state: { message: "Password aggiornata con successo!" } });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <form
        onSubmit={handleSetPassword}
        className="bg-white shadow-md rounded px-8 py-6 w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Imposta nuova password</h2>

        {error && <div className="text-red-600 text-sm mb-4">{error}</div>}

        <div className="mb-4">
          <label className="block text-gray-700 text-sm mb-1">Nuova password</label>
          <input
            type="password"
            className="border border-gray-300 rounded w-full px-3 py-2 focus:outline-none focus:ring focus:ring-green-300"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Almeno 8 caratteri"
            required
            minLength={8}
          />
          {password && (
            <p
              className={`text-sm mt-1 ${
                strength === "Debole"
                  ? "text-red-500"
                  : strength === "Media"
                  ? "text-yellow-500"
                  : "text-green-500"
              }`}
            >
              Forza password: {strength}
            </p>
          )}
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 text-sm mb-1">Conferma password</label>
          <input
            type="password"
            className="border border-gray-300 rounded w-full px-3 py-2 focus:outline-none focus:ring focus:ring-green-300"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Ripeti la nuova password"
            required
          />
        </div>

        <Button
          type="submit"
          variant="primary"
          disabled={loading}
          className={`w-full ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
        >
          {loading ? "Caricamento..." : "Salva"}
        </Button>
      </form>
    </div>
  );
}
